export const combineAddress = (data) => {

    const defaultAddressKeys = [ "address1", "address2", "city", "state", "country", "postalcode" ]
    let addressData = []

    for(const key of Object.keys(data)){
        if(defaultAddressKeys.includes(key)){
            if(data[key]){addressData.push(data[key])}
        }
    }

    return addressData.join(", ")

}

export const getAuthHeader = () => {
    return { 'authorization': `Bearer ${JSON.parse(localStorage.getItem('user')).accessToken}` }
}